import { CoverageBlockInput } from './coverageHoursOverlap';
import { TeamCoverageEntry } from './coverageHoursTeamUtils';
import { minutesOfDay } from './coverageHoursTimeUtils';

export type DraftCoverageBlock = {
  daysOfWeek: string[];
  startTime: string | null;
  endTime: string | null;
};

type Args = {
  draftBlocks: DraftCoverageBlock[];
  draftTeamId: string | null;
  bankedEntries: TeamCoverageEntry[];
  editingEntryId?: string;
  channelId: string;
  category: string;
  issue: string;
};

const UNPICKED_TEAM_ID = 'draft-team';

export function draftBlockId(index: number): string {
  return `draft-${index}`;
}

export function buildCoverageComparisonSet({
  draftBlocks,
  draftTeamId,
  bankedEntries,
  editingEntryId,
  channelId,
  category,
  issue,
}: Args): CoverageBlockInput[] {
  const banked = bankedEntries
    .filter(entry => entry.id !== editingEntryId)
    .flatMap(entry =>
      entry.coverageBlocks.map((coverageBlock, index) => ({
        blockId: `${entry.id}-${index}`,
        teamId: entry.teamId,
        channelId,
        category,
        issue,
        daysOfWeek: coverageBlock.daysOfWeek,
        startMinute: minutesOfDay(coverageBlock.startTime),
        endMinute: minutesOfDay(coverageBlock.endTime, coverageBlock.startTime),
      }))
    );

  const draft = draftBlocks.flatMap(({ daysOfWeek, startTime, endTime }, index) => {
    if (daysOfWeek.length === 0 || !startTime || !endTime) {
      return [];
    }

    return [
      {
        blockId: draftBlockId(index),
        teamId: draftTeamId ?? UNPICKED_TEAM_ID,
        channelId,
        category,
        issue,
        daysOfWeek,
        startMinute: minutesOfDay(startTime),
        endMinute: minutesOfDay(endTime, startTime),
      },
    ];
  });

  return [...banked, ...draft];
}
